import { type InputType, COMPANY_NAME_FC } from 'config'
import { fillObject } from 'utils'

export enum CreditRequestType {
  Universal = 'universal',
  OnHand = 'onhand',
}

export const noScoreToolTip = 'If there is no credit score for this value, then just type 000.'

export const CreditScoreTypes: Record<string, string> = {
  equifax: 'Equifax',
  experian: 'Experian',
  transunion: 'Transunion',
}

export const CreditScoreTypeList = Object.keys(CreditScoreTypes)

export const defaultInputs = (): Record<string, InputType> => {
  return {
    creditRequestType: {
      inputType: 'select',
      title: 'Credit Request Type',
      options: {
        [CreditRequestType.Universal]: `${COMPANY_NAME_FC} to Pull Credit`,
        [CreditRequestType.OnHand]: 'Credit Report on Hand',
      },
      hasDefaultOption: true,
      required: true,
    },
    creditFileKey: {
      inputType: 'file',
      title: 'Please upload your credit score pdf to input your scores.',
      span: 2,
      required: true,
      acceptDocument: true,
    },
    ...fillObject(CreditScoreTypeList, (key: string) => ({
      inputType: 'text',
      type: 'creditScore',
      tooltip: noScoreToolTip,
      title: `${CreditScoreTypes[key]} Score`,
      required: true,
    })),
    priceScore: {
      inputType: 'select',
      title: '',
      options: [],
      hasDefaultOption: true,
    },
  }
}
